import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';

export interface PreProcessingMetric {
  label: string;
  value: number;
}

export interface PreProcessingMetrics {
  extensionByCount: PreProcessingMetric[];
  extensionBySize: PreProcessingMetric[];
  typeByCount: PreProcessingMetric[];
  typeBySize: PreProcessingMetric[];
  projectSourceSize: number;
  projectOutputSize: number;
}

/** Pre-processing metrics for the whole project, or one collection when collectionId is given. */
export function usePreProcessingMetrics(projectId: string, collectionId?: string) {
  const base = collectionId
    ? `/project/${projectId}/collection/${collectionId}`
    : `/project/${projectId}`;
  return useQuery<PreProcessingMetrics>({
    queryKey: ['preProcessingMetrics', projectId, collectionId ?? null],
    queryFn: () => api.get<PreProcessingMetrics>(`${base}/preprocessingmetrics`),
    enabled: !!projectId,
  });
}
